const RolesEnum = {
    GERENCIA: {
        rol_id: 6,
        rol_nombre: "GERENCIA"
    },
    ADMINISTRADOR: {
        rol_id: 1,
        rol_nombre: "ADMINISTRADOR"
    },
    ESTANDAR: {
        rol_id: 2,
        rol_nombre: "ESTÁNDAR"
    },
    LOGISTICA: {
        rol_id: 3,
        rol_nombre: "LOGÍSTICA"
    },
    CONTABILIDAD: {
        rol_id: 4,
        rol_nombre: "CONTABILIDAD"
    },
    INVENTARIO: {
        rol_id: 5,
        rol_nombre: "INVENTARIO"
    },
    TESORERIA: {
        rol_id: 7,
        rol_nombre: "TESORERIA"
    },
    JEFE_ALMACEN: {
        rol_id: 8,
        rol_nombre: "JEFE_ALMACEN"
    },
    SUPER: {
        rol_id: 0,
        rol_nombre: "SUPER"
    },
}

export default RolesEnum